import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FacetedSearch } from './FacetedSearch';
import { query, submitSearchFacet, updateFilterOption } from '../Actions/FacetedSearch.action';
import { SortCriteria } from './SortCriteria';
import FilterTag from './FilterTags';
import { PRODUCT_VIEW_CACHED } from '../constants';
import { useDebounce } from '../Hooks/useDebounce';
import ClearFiltersButton from './ClearFiltersButton';

function searchResultDataChange(dom) {
    if (dom == null) {
        return;
    }

    const container = document.createElement('div');
    container.innerHTML = dom;

    const existingResult = document.getElementById('search-result');
    const tempResult = container.querySelector('#search-result');
    const existingFilter = existingResult.querySelector('#facetedSearchCompact');
    const tempFilter = tempResult.querySelector('#facetedSearchCompact');
    
    function replaceNode(node, newNode) {
        node.parentNode.replaceChild(newNode, node);
    }
    
    // move existingFilter from existingResult to tempResult
    replaceNode(tempFilter, existingFilter);

    // replace existingResult with tempResult ( newResult )
    replaceNode(existingResult, tempResult);

    // bootstrap react components if any exists in the search result
    window.__litium.bootstrapComponents();
}

export function FacetedSearchContainer() {
    const dispatch = useDispatch();
    const {
        sortCriteria,
        facetFilters: globalFacetFilters,
        navigationTheme,
        productsViewCachedId,
    } = useSelector((state) => state.facetedSearch);

    const [ facetFilters, setFacetFilters ] = useState(globalFacetFilters || []);
    const previousCachedId = useRef(productsViewCachedId);
    
    const submitSearchFacetDebounced = useDebounce((updatedFilters) => {
        dispatch(submitSearchFacet(updatedFilters));
    }, 500);

    const onFacetChange = useCallback((filter, option) => {
        const updatedFilters = updateFilterOption(facetFilters, filter, option);
        
        setFacetFilters(updatedFilters);
        submitSearchFacetDebounced(updatedFilters);
    }, [ setFacetFilters, facetFilters ]);
    
    useEffect(() => {
        if (previousCachedId.current === productsViewCachedId) {
            return;
        }
        
        setFacetFilters(globalFacetFilters);
        previousCachedId.current = productsViewCachedId;
    }, [ globalFacetFilters, productsViewCachedId ]);

    useEffect(() => {
        dispatch(query(window.location.search.substring(1) || '', false));
    }, [ dispatch ]);

    useEffect(() => {
        const productViewCached = window.__litium?.cache?.[PRODUCT_VIEW_CACHED] ?? {};
        
        if (productViewCached.used) {
            return;
        }

        productViewCached.used = true;
        searchResultDataChange(productViewCached.productsView);
    });

    return (
        <div className="container">
            <FilterTag facetFilters={globalFacetFilters}
                       navigationTheme={navigationTheme ?? ''} />
            <div className="compact-filter">
                <div className="compact-filter__row row align-bottom justify-between">
                    <div className="columns small-6 medium-4 large-2">
                        <SortCriteria sortCriteria={sortCriteria?.sortItems} />
                    </div>
                    <div className="columns small-6 medium-4 large-2">
                        <ClearFiltersButton />
                    </div>
                </div>
                <FacetedSearch facetFilters={facetFilters}
                               onFacetChange={onFacetChange} />
            </div>
        </div>
    );
}

export default FacetedSearchContainer;
